"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextKeys = void 0;
/**
 * Possible keys for the Next page context or response locals.
 */
var ContextKeys;
(function (ContextKeys) {
    ContextKeys["tenant"] = "tenant";
    ContextKeys["getCsrfToken"] = "getCsrfToken";
    ContextKeys["csrfToken"] = "csrfToken";
    ContextKeys["authToken"] = "authToken";
    ContextKeys["sdkKey"] = "sdkKey";
    ContextKeys["uid"] = "uid";
    ContextKeys["locale"] = "locale";
    ContextKeys["acceptLanguage"] = "acceptLanguage";
    ContextKeys["timeZone"] = "timeZone";
    ContextKeys["originHeaders"] = "originHeaders";
    ContextKeys["switchUserId"] = "switchUserId";
    ContextKeys["branchName"] = "branchName";
    ContextKeys["routeInfo"] = "routeInfo";
    ContextKeys["pageScripts"] = "pageScripts";
    ContextKeys["canSwitchUser"] = "canSwitchUser";
    ContextKeys["parentFrameId"] = "parentFrameId";
})(ContextKeys || (exports.ContextKeys = ContextKeys = {}));
//# sourceMappingURL=index.js.map